import React from 'react';
import { ToastContainer } from 'react-toastr';
import { graphql, compose } from 'react-apollo';
import CONFIGURATIONS_QUERY from '../../../graphql/Configurations';
import SET_SLIDESHOW_QUERY from '../../../graphql/SetSlideshow';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import Sidebar from '../../../components/Sidebar/index';
import Form from './form';

class Configurations extends React.PureComponent {
  setSlideshow = (images) => {
    const { mutate } = this.props;
    mutate({
      variables: {
        urls: images,
      },
    })
      .then(() => {
        this.toastr.success('Imágenes actualizadas correctamente');
        this.props.refetch();
      })
      .catch(() => {
        this.toastr.error('Ocurrió un error al intentar actualizar las imágenes');
      });
  };

  onLogout = () => {
    this.props.history.push('/login');
  };

  render() {
    return (
      <div>
        <ToastContainer
          ref={(ref) => { this.toastr = ref; }}
          className="toast-top-right"
        />
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="configurations" onLogout={this.onLogout} />
              </div>
              <div className="col-lg-9 col-md-9 col-sm-12">
                <h1 className="heading">Mantenedor de configuraciones</h1>
                <Form
                  configuration={this.props.configurations}
                  onSubmit={this.setSlideshow}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}


const withConfig = graphql(CONFIGURATIONS_QUERY, {
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    configurations: data.getConfigs,
    refetch: data.refetch,
  }),
});

const withConfigUpdate = graphql(SET_SLIDESHOW_QUERY);

export default compose(withConfig, withConfigUpdate)(Configurations);



// WEBPACK FOOTER //
// ./src/containers/Admin/Configuration/index.js